// Recursive function for converting an object in snake_case to camelCase
export function snakeToCamelCase(obj) {
  if (!obj) {
    console.warn('snakeToCamelCase called with null or undefined');
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(v => snakeToCamelCase(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
      if (key != 'condition_sequence' && obj[key] !== null && obj[key].constructor === Object) {
        result[camelKey] = snakeToCamelCase(obj[key]);
      }
      else {
        // We don't want to recursively snakeToCamelCase the whole condition_sequence object. Just the name
        result[camelKey] = obj[key];
      }
      return result;
    }, {});
  } else {
    return obj;
  }
}
